import React, { useState } from 'react'
import Renderif from './renderif'
import { AiOutlineClose, AiOutlineTags } from 'react-icons/ai'

export default function TipCard({ tip, i = 0, tag = "", onClick = null, onDeleteTip, isAdmin }) {


  const [state, setState] = useState({
    show_detail: false
  })

  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
  const getVideo = (link) => {
    let video = 'https://www.youtube.com/watch?v=S8nTuZR059k';
    const urlSearchParams = new URLSearchParams(video);
    const params = Object.fromEntries(urlSearchParams.entries());

    let v = getParameterByName('v', link)
    return v
  }

  getVideo();


  return (
    <>

      <Renderif isTrue={state.show_detail}>
        <div className='overlay'>

          <div className='container position-relative'>

            <div className='bv-icon bv-icon--big bg-white cursor-pointer r-100 shadow absolute-top-right m-2' onClick={() => {
              setState({ ...state, show_detail: false })
            }}>
              <AiOutlineClose size={22}></AiOutlineClose>
            </div>

            <div className='bv-card'>
              <Renderif isTrue={tip.image !== null && getVideo(tip.video) === null}>
                <div className='bv-card-img bv-card-img--full' style={{ backgroundImage: `url('${tip.image}')` }}></div>
              </Renderif>

              <Renderif isTrue={getVideo(tip.video) !== null}>
                <iframe width="100%" height="415" src={`https://www.youtube.com/embed/${getVideo()}`} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              </Renderif>

              <div className='ps-2'>
                <div className='f-16 bold text-gray p-1 pb-0 '>{tip.title}</div>
                <div className='f-16 text-gray p-1'>{tip.description}</div>
                <div className='my-5'></div>
                <div className='d-flex align-items-end'>
                  <div className='f-12 bold text-blue p-1'>Tip #{i + 1}</div>
                  <div className='col'></div>
                  <div className={`text-white ${tag !== "" ? 'bg-purple' : 'bg-orange'} bold f-14 px-3 py-1 my-1`}>{tag !== "" ? 'Nuevo!' : '!Asignado'}</div>
                </div>
              </div>


              <div className='d-flex align-items-center px-2 py-2'>

                <div className='bv-tag bv-tag--gray'>
                  <div className='bv-icon'><AiOutlineTags></AiOutlineTags></div>
                  <div className='text-gray pe-2'>Tip</div>
                </div>
                <div className='bv-tag bv-tag--gray'>
                  <div className='bv-icon'><AiOutlineTags></AiOutlineTags></div>
                  <div className='text-gray pe-2'>bienvivir</div>
                </div>
                <div className='col'></div>
            <Renderif isTrue={isAdmin}>
            <div className='ps-2 text-red text-decoration-underline cursor-pointer f-12' onClick={() => {
                  setState({ ...state, show_detail: false })
                  onDeleteTip(tip)
                }}>Eliminar</div>
            </Renderif>
              </div>
            </div>

          </div>
        </div>

      </Renderif>

      <div className='bv-card w-100 mt-2 cursor-pointer mobile-d-inline' onClick={() => {

        if (onClick !== null) {
          onClick()
          return
        }
        setState({ ...state, show_detail: true })
      }}>
        <Renderif isTrue={tip.image !== null}>
          <div className='bv-card-img bv-card-img--small' style={{ backgroundImage: `url('${tip.image}')` }}></div>
        </Renderif>


        <div className='f-12 bold text-black p-1 pb-0 text-ellipsis'>{tip.title}</div>
        {/* <div className='f-12 text-gray p-1 text-ellipsis-2'>{tip.description}</div> */}
        {/* <div className='col'></div>
        <div className='d-flex align-items-end'>
          <div className='f-10 bold text-blue p-1' >Tip #{i + 1}</div>
          <div className='col'></div>

          <div className={`text-white ${tag !== '' ? 'bg-purple' : 'bg-orange'} bold f-10 px-3 py-1 my-1`}>{tag !== '' ? 'Nuevo!' : '!Asignado'}</div>





        </div> */}
      </div>
    </>
  )
}
